module.exports = __webpack_public_path__ + "assets/images/payspace-not-active.d22bd1ce43ef65970c7b1e04f50a6395.webp";